/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Color_ByInputs */

const en_ui_color_by = /** @type {(inputs: Ui_Color_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color by`)
};

const de_ui_color_by = /** @type {(inputs: Ui_Color_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Färben nach`)
};

/**
* | output |
* | --- |
* | "Color by" |
*
* @param {Ui_Color_ByInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by = /** @type {((inputs?: Ui_Color_ByInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_ByInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by(inputs)
	return de_ui_color_by(inputs)
});